import ProductFooterActions from './product-footer-actions';

export default ProductFooterActions;
